export default __webpack_public_path__ + "static/media/chevron-up.6fcf1de8.svg";